import React from 'react';

// Parst Objekt | JSON-String | Leer -> Objekt (keine Arrays).
const parseObj = (v) => {
  if (v && typeof v === 'object' && !Array.isArray(v)) return v;
  if (typeof v === 'string' && v.trim()) {
    try {
      const p = JSON.parse(v);
      return p && typeof p === 'object' && !Array.isArray(p) ? p : {};
    } catch {
      return {};
    }
  }
  return {};
};

/**
 * JsonObjectEditor — Formular-Editor fuer ein JSON-OBJEKT-Feld (F7, z. B. contract_data).
 * Pendant zu JsonTableEditor (Arrays).
 *
 * - value:    JSON-String eines Objekts (Speicherformat unveraendert).
 * - onChange: (jsonString) => void.
 * - fields:   [{ key, label, type?: 'text'|'number'|'date'|'checkbox', placeholder? }]
 * - Unbekannte Keys bleiben erhalten (kein Datenverlust).
 */
const JsonObjectEditor = ({ value, onChange, fields, isDarkMode, t }) => {
  const obj = parseObj(value);

  const setField = (key, type, raw) => {
    const val = type === 'number' ? (raw === '' ? '' : Number(raw)) : raw;
    onChange(JSON.stringify({ ...obj, [key]: val }));
  };

  const inputCls = `w-full px-2 py-1.5 text-sm rounded-lg border focus:outline-none focus:ring-2 ${
    isDarkMode
      ? 'bg-gray-800/40 border-white/20 text-white placeholder-white/30 focus:ring-blue-400/50'
      : 'bg-white border-slate-200 text-slate-800 placeholder-slate-400 focus:ring-brand/40'
  }`;
  const labelCls = `block text-xs mb-1 ${isDarkMode ? 'text-white/50' : 'text-slate-500'}`;

  return (
    <div className={`rounded-xl border p-3 grid grid-cols-1 sm:grid-cols-2 gap-3 ${
      isDarkMode ? 'border-white/10 bg-gray-900/20' : 'border-slate-200 bg-slate-50/60'
    }`}>
      {fields.map((f) => (
        f.type === 'checkbox' ? (
          <label key={f.key} className="sm:col-span-2 flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={!!obj[f.key]}
              onChange={(e) => setField(f.key, 'checkbox', e.target.checked)}
              className="w-4 h-4"
            />
            <span className={`text-sm ${isDarkMode ? 'text-white/80' : 'text-slate-700'}`}>{f.label}</span>
          </label>
        ) : (
          <div key={f.key}>
            <label className={labelCls}>{f.label}</label>
            <input
              type={f.type === 'number' ? 'number' : f.type === 'date' ? 'date' : 'text'}
              step={f.type === 'number' ? 'any' : undefined}
              value={obj[f.key] ?? ''}
              placeholder={f.placeholder || ''}
              onChange={(e) => setField(f.key, f.type, e.target.value)}
              className={inputCls}
            />
          </div>
        )
      ))}
    </div>
  );
};

export default JsonObjectEditor;
